module.exports = __webpack_public_path__ + "img/app_store_intro.15954cd1.jpg";